import { compose } from 'redux';
import { isDevelopmentMode } from '../services/env';

export const composeEnhancers =
    (isDevelopmentMode() &&
        window &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
